import { Page } from "../../../../helbest";
import HeaderBack from "../../../../helbest/HeaderBack/HeaderBack";
import { useOrderDetailsQuery } from "../../../../saleor/api";
import {
  orderAddressTransformer,
  orderDetailsTransformer,
  orderDateTransformer,
} from "../../../../services/objectTransformer/orders";
import Addresses from "./Addresses/Addresses";
import OrderItem from "./OrderItem/OrderItem";
import Summary from "./Summary/Summary";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { useMemo } from "react";
import Loading from "../../../components/Loading/Loading";

const OrderDetails = (props) => {
  const params = useParams();
  const location = useLocation();
  const { data, loading } = useOrderDetailsQuery({
    variables: { id: params.id },
  });
  const { t } = useTranslation();

  const prefilled = useMemo(() => {
    const meta =
      location.state?.metadata || location.state?.notificationMetadata || null;
    const stateCreated = location.state?.created_at;
    const stateStatus = location.state?.status;
    const statePaymentStatus = location.state?.payment_status;

    if (!meta) return null;

    // Currency may come from metadata, or fall back to a sensible default
    const currency = meta?.currency || meta?.currency_code || "";

    // Transform product object to lines array if needed
    let lines = meta?.lines || meta?.items || [];
    if (meta?.product && !lines.length) {
      // If we have product but no lines, create a line from product
      lines = [
        {
          id: meta.product.id || meta.id,
          product_name: meta.product.name || "",
          quantity: meta.quantity || 1,
          thumbnail: meta.product.thumbnail || null,
          currency,
          total_discount: 0,
          item_price: 0,
          total_price: 0,
          payable_amount: 0,
        },
      ];
    } else {
      // Make sure any pre-existing lines also carry the currency
      lines = lines.map((line) => ({
        currency: line?.currency || currency,
        ...line,
      }));
    }

    // Transform date using orderDateTransformer
    const dateStr = stateCreated || meta?.created_at || meta?.created;
    const dateTransformed = orderDateTransformer({ created: dateStr });

    return {
      id: meta?.saleor_order_id || meta?.order_id || meta?.id || params.id,
      number: meta?.number || meta?.order_number || meta?.id?.toString() || "",
      created: dateTransformed?.created || dateStr || "--",
      status: stateStatus || meta?.status || "",
      payment_status: statePaymentStatus || meta?.payment_status || "",
      currency,
      payable_amount: meta?.payable_amount || 0,
      total_price: meta?.total_price || 0,
      total_discount: meta?.total_discount || 0,
      wallet_amount: meta?.wallet_amount || 0,
      tax: meta?.tax || 0,
      shipping_price: meta?.shipping_price || 0,
      lines: lines,
    };
  }, [location.state, params.id]);

  const orderRemote = data?.order && orderDetailsTransformer(data?.order);
  const order = orderRemote || prefilled;
  const addresses = data?.order && {
    shipping_address: orderAddressTransformer(data?.order.shippingAddress),
    billing_address: orderAddressTransformer(data?.order.billingAddress),
    shippingCompanyName: data?.order?.shippingAddress.companyName,
    billingCompanyName: data?.order?.billingAddress.companyName,
  };

  // Determine back URL based on where we came from
  const backUrl = useMemo(() => {
    if (location.state?.notification_id) {
      return "/notifications";
    }
    return "/my-orders/";
  }, [location.state]);

  return (
    <Page
      className="page-profile"
      back={true}
      address="/my-orders/"
      customHeader={
        <HeaderBack title={t("detailmodel.order_details")} url={backUrl} />
      }
      headerFix
    >
      <div className="factors-holder factors-scroll hei-100p page-factor-factors-container">
        {loading && !order ? (
          <div className="text-center mt-2">
            <Loading />
          </div>
        ) : (
          <>
            <div>
              <h5 style={{ color: "#001860", fontSize: "18px" }}>
                {t("cart.order_summary")}
              </h5>
              <Summary {...order} />
              <Addresses {...addresses} />
            </div>
            <div>
              <h5 className="orders-detail-purchased-header">
                {t("orderdetails.order_items")}
              </h5>
              {order?.lines
                ?.filter((item) => item.product_name !== "service_fee")
                .map((item) => (
                  <OrderItem
                    {...item}
                    currency={item?.currency || order?.currency}
                    key={item.id}
                  />
                ))}
            </div>
          </>
        )}
      </div>
    </Page>
  );
};

export default OrderDetails;